module.exports = __webpack_public_path__ + "media/exposure.d6f25faf.mp4";